module.exports = "<ion-app>\n  <ion-split-pane>\n\n    <ion-router-outlet main></ion-router-outlet>\n\n  </ion-split-pane>\n\n</ion-app>\n"